import { render, staticRenderFns } from "./WellfulLogo.vue?vue&type=template&id=4ae44a6c&scoped=true"
import script from "./WellfulLogo.vue?vue&type=script&lang=js"
export * from "./WellfulLogo.vue?vue&type=script&lang=js"
import style0 from "./WellfulLogo.vue?vue&type=style&index=0&id=4ae44a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae44a6c",
  null
  
)

export default component.exports